import React from 'react'

export default function TypefaceBadge(props) {
  return (
    <div className='typefaceBadge'>
      {props.typeface.badge}
    </div>
  )
}
